/** A 12-hour label (including Noon and Midnight) as a 24-hour `HH:mm` time. */
export function convertTo24Hour(time12: string): string {
  if (!time12) return ''
  if (time12 === 'Noon') return '12:00'
  if (time12 === 'Midnight') return '00:00'
  const [time, ampm] = time12.split(' ')
  if (time === undefined || time.length === 0) return ''
  const [hours, minutes] = time.split(':')
  if (hours === undefined || hours.length === 0) return ''
  let hour = parseInt(hours, 10)
  if (ampm === 'PM' && hour !== 12) hour += 12
  else if (ampm === 'AM' && hour === 12) hour = 0
  return `${String(hour).padStart(2, '0')}:${minutes !== undefined && minutes.length > 0 ? minutes : '00'}`
}
